import { render, staticRenderFns } from "./MarginListAdd.vue?vue&type=template&id=4600951c&scoped=true"
import script from "./MarginListAdd.vue?vue&type=script&lang=js"
export * from "./MarginListAdd.vue?vue&type=script&lang=js"
import style0 from "./MarginListAdd.vue?vue&type=style&index=0&id=4600951c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4600951c",
  null
  
)

export default component.exports